// lib/components/toggle/check-box/check-box.tsx
import classNames from "classnames";
import { forwardRef } from "react";
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
var Checkbox = forwardRef(
  ({ label, className, style, ...props }, ref) => {
    return /* @__PURE__ */ jsxs(
      "label",
      {
        style: {
          display: "inline-flex",
          alignItems: "center",
          cursor: "pointer",
          userSelect: "none"
        },
        children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              type: "checkbox",
              className: classNames("checkbox", className),
              ref,
              style: {
                cursor: "pointer",
                ...style
              },
              ...props
            }
          ),
          /* @__PURE__ */ jsx("span", { className: "pl-2", children: label })
        ]
      }
    );
  }
);
Checkbox.displayName = "Checkbox";

export {
  Checkbox
};
